module.exports = __webpack_public_path__ + "assets/lessons/pl/audio/Audio 3.pdf";